import * as React from 'react';
import ModalContainer from '@af-common/Common/_containers/ModalContainer';
import { DocumentStatusTypes } from '../../Document/_stores/DocumentStore';
import PromptContainer from '@af-common/Common/_containers/PromptContainer';
import { Trans } from "react-i18next";
import Loader from '@af-common/Common/_components/Loader';
import { ButtonBase } from '@mui/material'

export type Props = {
	onSave?: Function
	setStatus?: Function
	orderProduct?: (id:string, productType:string) => void
	status?: string
	savedId?: string
	store?: any
	sendToast?: Function
	onNameChange?: Function
	documentName?: string
}

type State = {
	nameOpened: boolean
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class SaveButton extends React.Component<Props> {

	state = {
		nameOpened: false
	} as State

	private onNameClose		= () 			=> this.setState({nameOpened: false});
	private onNameOpen		= () 			=> this.setState({nameOpened: true});
	private onNamePattern	= (name:string)	=> this.props.onNameChange(name);

	private onSave() {
		if(this.props.store.getIn(['create','document','name']) == "Untitled") {
			this.props.sendToast(<T>Give a name to your pattern first!</T>)
			return;
		}

		let fd = new FormData()
		fd.append("store", JSON.stringify(this.props.store.toJS()))
		this.props.onSave(fd);
	}

	render = () => <>
		<ButtonBase style={ {borderRadius: '3px', marginBottom: '15px'} } >
			<div onClick={() => this.onNameOpen()} className="action-buttons-icon grey-border">
				<img src="static/img/icons/save-icon.svg" alt="" width="25" height="25" />
				<div className="text">SAVE</div>
			</div>
		</ButtonBase>
		{this.props.status == DocumentStatusTypes.Saving && <ModalContainer preventClose opened={true} animate content={<Loader />} />}
		{/* Name Dialog */}
		<PromptContainer
			opened={this.state.nameOpened}
			title={<T>Name your pattern</T>}
			onChange={this.onNamePattern}
			onClose={this.onNameClose}
			actions={{
				"Confirm": () => {
					this.onNameClose();
					this.onSave();
				}
			}}
			initialValue={this.props.documentName}
			dismissible
		/>
		<PromptContainer
			opened={this.props.status == DocumentStatusTypes.Saved}
			title={<T>Your design has been saved!</T>}
			message={<T>You can keep working or order it right now!</T>}
			actions={{
				"Order now": () => {
					this.props.setStatus(DocumentStatusTypes.Edit);
					this.props.orderProduct(this.props.savedId, 'pattern');
				}
			}}
			onClose={() => {
				this.props.setStatus(DocumentStatusTypes.Edit);
			}}
			dismissible={true}
			dismissibleString={<T>Keep Working</T>}
		/>
	</>
}